export default function PHP_convert_cyr_string() {
  return (
    <div>
      <h1>PHP_convert_cyr_string</h1>
    </div>
  );
}
